
import React from 'react'
// USE INSIDE BUTTONS OR OTHER AREAS
export function CommonButtonSpinner() {
   return (
      <div className="spinner_bg_1">
         <span class="loader1"></span>
      </div>
   )
}

// USE FULL PAGE LOADINGS
export function CommonPageSpinner() {
   return (
      <div className="spinner_bg">
         <span class="loader"></span>
      </div>
   )
}
